import { TemplateListCardComponentProps } from '@wix/wix-studio-marketplace-lib/dist/types/components/TemplateGallery/TemplateCardListItems/TemplateCardListItems';
import React from 'react';
import { TemplateCard } from '@wix/wix-studio-marketplace-lib';
import { buildTemplatePageLink } from '@utils/profileTemplatesUtils';
import { TemplateGalleryCard as LibraryTemplateGalleryCard } from '@wix/wix-studio-marketplace-lib/dist/types/types/template';
import { Box } from '@wix/design-system';
import CardInfo from '@components/Templates/TemplateGallery/TemplateCard/CardInfo';
import { TemplateGalleryCard } from '@common/types';
import FeatureTags from '@components/Templates/TemplateGallery/TemplateCard/FeatureTags';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { usePriceCalculation } from '@components/Hooks/usePriceCalculation';

interface TemplateCardInfoProps {
  template: LibraryTemplateGalleryCard;
  hovered: boolean;

  isMobileView: boolean;
}

const TemplateCardInfo: React.FC<TemplateCardInfoProps> = ({
  template,
  hovered,
  isMobileView,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { getLocalizedTotalPrice } = usePriceCalculation();
  return (
    <Box paddingTop="12px" display="block">
      <CardInfo
        template={template as TemplateGalleryCard}
        hovered={hovered}
        t={t}
        language={language}
        isMobileView={isMobileView}
        titleProps={{
          size: isMobileView ? 'tiny' : 'medium',
          weight: 'normal',
        }}
        priceTextProps={{
          weight: 'normal',
          getLocalizedPrice: getLocalizedTotalPrice,
        }}
        showFeatures={false}
      />
      <FeatureTags
        features={template.apps}
        isMobileView={isMobileView}
        disableFiltering={true}
      />
    </Box>
  );
};

interface WrappedTemplateCardProps extends TemplateListCardComponentProps {
  logTemplateClick: (templateId?: string, clickType?: string) => void;
  isMobileView: boolean;
}

const WrappedTemplateCard: React.FC<WrappedTemplateCardProps> = ({
  logTemplateClick,
  isMobileView,

  ...props
}) => {
  const { t } = useTranslation();
  return (
    <TemplateCard
      t={t}
      onClick={() =>
        logTemplateClick(props.template.id || '', 'go to template')
      }
      templateHref={buildTemplatePageLink(props.template.id)}
      CardInfo={(cardInfoProps) => (
        <TemplateCardInfo {...cardInfoProps} isMobileView={isMobileView} />
      )}
      anchorProps={{
        target: '_blank',
        rel: 'noreferrer',
      }}
      {...props}
    />
  );
};

export default WrappedTemplateCard;
